import { render } from "./GameModal.vue?vue&type=template&id=0062c060&scoped=true"
import script from "./GameModal.vue?vue&type=script&lang=js"
export * from "./GameModal.vue?vue&type=script&lang=js"

import "../../../assets/css/landing.css?vue&type=style&index=0&id=0062c060&scoped=true&lang=css"
import "./GameModal.vue?vue&type=style&index=1&id=0062c060&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0062c060"

export default script